export default "__VITE_ASSET__kaDfvpC$__"